import * as React from 'react';
import {
    Box,
    Card,
    // CardActions,
    // Button,
    Typography,
    useTheme,
    SimplePaletteColorOptions,
} from '@mui/material';
// import HomeIcon from '@mui/icons-material/Home';
// import CodeIcon from '@mui/icons-material/Code';
import { useTranslate } from 'react-admin';

import publishArticleImage from './welcome_illustration.svg';

const Welcome = () => {
    const translate = useTranslate();
    const theme = useTheme();

    const primaryColor = theme?.palette?.primary as SimplePaletteColorOptions;

    return (
        <Card
            sx={{
                background: theme =>
                    `linear-gradient(to bottom, #ffffff33, #ffffff00), linear-gradient(to bottom, ${primaryColor.light}00, ${primaryColor.dark}ff), ${primaryColor.main}`,
                color: '#fff',
                padding: '20px',
            }}
        >
            <Box display="flex">
                <Box flex="1">
                    <Typography variant="h5" component="h2" gutterBottom>
                        {translate('pos.dashboard.welcome.title')}
                    </Typography>
                    <Box maxWidth="40em">
                        <Typography variant="body1" component="p" gutterBottom>
                            {translate('pos.dashboard.welcome.subtitle')}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    display={{ xs: 'none', sm: 'none', md: 'block' }}
                    sx={{
                        background: `url(${publishArticleImage}) top right / cover`,
                        marginLeft: 'auto',
                        alignSelf: 'center',
                    }}
                    width="16em"
                    height="9em"
                    overflow="hidden"
                />
            </Box>
        </Card>
    );
};

export default Welcome;
